<template>
    <div class="nodata">
         <img src="../assets/nodata.jpg" alt=""/>
         <div class="txt">{{langSet=='cn'?'暂无数据':'No Data'}}</div>
    </div>
</template>

<script>
export default {
  props: {
    
  },
  data() {
    return {
        langSet:''
    };
  },
  created() {
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
    .nodata{
        // background: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
          width: 180px;
        }
        .txt{
          margin-top: 40px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
        }

    }
    @media only screen and (max-width: 767px) {
      .nodata{
        img{
          width: 110px;
       }
        .txt{
          font-weight: 400;
          font-size: 14px;
          margin-top: 25px;
        }
      } 
    }
</style>